<template>
  <div>
    <button
      v-if="
        $IsUserInRole('VertragsmanagementVerwaltung') ||
          $IsUserInRole('VertragsmanagementUniaVertragsverantworlich')
      "
      v-b-tooltip.hover
      v-b-modal.craeteNewContract
      onclick
      type="button"
      placement="bottom"
      title="Neuer Vertrag hinzufügen"
      class="btn btn-success"
    >
      <i class="fas fa-plus" />
    </button>
    <b-modal
      id="craeteNewContract"
      ref="craeteNewContract"
      title="Neuer Vertrag erstellen"
      hide-footer
      no-fade
      size="xl"
    >
      <template>
        <div class="d-block mb-4">
          <b-alert
            variant="info"
            show
          >
            <b>Achtung: </b>Vertragsnummer kann nach dem Erstellen des Vertrages
            nicht mehr geändert werden.
          </b-alert>

          <u-error-handling
            v-if="errorObject"
            :error-object="errorObject"
          />
          <u-loader
            v-if="isLoading"
            text="Vertrag wird erstellt. Dies kann eine Weile dauern..."
          />
          <div
            v-else
            class="form-group"
          >
            <b-container class="pb-0 pt-0">
              <b-row>
                <label
                  class="pl-0 col-3 mt-3 defaultLabel"
                >Vertragsnummer</label>
                <div class="col-9 pl-0">
                  <v-text-field
                    v-model="newContractInformation.contractNumber"
                    class="mt-0"
                    label="Vertragsnummer"
                    required
                  />
                  <u-validation-checker
                    v-model="requiredProperties"
                    :is-empty="!newContractInformation.contractNumber"
                    :section="validationSection"
                    property-name="contractNumber"
                  />
                </div>
              </b-row>
            </b-container>
            <div class="form-group">
              <b-container class="pb-0 pt-0">
                <b-row>
                  <label
                    class="pl-0 col-3 mt-3 defaultLabel"
                  >Erster Vertragsabschluss</label>
                  <div class="col-9 pl-0">
                    <u-date-picker
                      v-model="newContractInformation.firstContractConclusion"
                      label="Erster Vertragsabschluss"
                      required
                      transfer="true"
                    />
                  </div>
                </b-row>
              </b-container>
            </div>
            <b-button
              variant="success"
              :disabled="requiredProperties.length != 0"
              @click="createNewContract()"
            >
              Erstellen
            </b-button>
            <b-button
              class="ml-2 btn-danger"
              variant
              @click="hideModal"
            >
              Abbrechen
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import UDatePicker from "@/components/common/UDatePicker.vue";
import { CreateNewContract } from "@/services/contract.service.js";
export default {
  components: {
    UDatePicker,
  },
  data() {
    return {
      validationSection: "Vertrag",
      newContractInformation: {
        contractNumber: "",
        firstContractConclusion: "",
      },
      errorObject: null,
      isLoading: false,
      requiredProperties: [],
    };
  },
  methods: {
    hideModal() {
      this.$refs["craeteNewContract"].hide();
    },
    createNewContract() {
      this.errorObject = null;
      this.isLoading = true;

      CreateNewContract(
        this.newContractInformation.contractNumber,
        this.newContractInformation.firstContractConclusion,
        () => {
          this.$router.push({
            path: `/contract-overview/${this.newContractInformation.contractNumber}/1`,
            quey: { source: this.$route.path },
          });
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>
